import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

function CommentModal({
  showSuccessMessage,
  hideCommentModal,
  handleCommentSubmit,
}) {
  const [comment, setComment] = useState("");
  const notify = (m) => toast.success(m);

  useEffect(() => {
    if (showSuccessMessage === true) {
      notify("Comment submitted successfully!");
    }
  }, [showSuccessMessage]);

  return (
    <>
      <div className="w-full md:min-w-[520px]" style={{ minHeight: '300px' }}>
        <p className="text-xl text-dimgray-200 font-bold py-4 px-6 border-b border-whitesmoke-100">
          Add a Comment
        </p>

        <div className="gap-0 flex flex-col p-6">
          <div className="flex flex-col gap-1.5">
            <p className="text-dimgray-200">Comment</p>
            <textarea
              rows={3}
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
              }}
              className="border border-dimgray-100 h-52 resize-none focus:outline-none p-4"
            />
          </div>

          <div className="flex gap-3 mt-10 justify-end">
            <button
              onClick={hideCommentModal}
              className="border  rounded-2xl py-3 px-6 border-dimgray-200 text-dark-blue-100 font-semibold"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleCommentSubmit(comment);
                setComment("");
                hideCommentModal();
              }}
              className="border rounded-2xl py-3 px-6 border-dimgray-200 bg-dark-blue-100 text-white font-semibold"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommentModal;
